// extracted by mini-css-extract-plugin
export default {"block":"BlockPause_block__vgIgX","load":"BlockPause_load__GpvBN","second":"BlockPause_second__6+fjv","icon":"BlockPause_icon__T-na3"};